import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import PasswordRecoveryForm from './components/PasswordRecoveryForm';
import PhoneVerifyForm from './components/PhoneVerifyForm';
import { useHistory } from 'react-router-dom';
import AuthFormPage from './components/AuthFormPage';
import Typography from '@material-ui/core/Typography';
import Button from '../../components/Button';

const useStyles = makeStyles({
  text: {
    marginTop: '1rem',
    marginBottom: '2rem',
    maxWidth: '15rem',
  },
  circle: {
    background: 'rgba(255,255,255,0.7)',
    width: '25rem',
    height: '25rem',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderColor: '#888888',
    borderWidth: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  }
});

const STAGE_REQUEST = 'request';
const STAGE_VERIFY = 'verify';

const METHOD_EMAIL = 'email';
const METHOD_MOBILE = 'mobile';

const PasswordRecoveryPage = ({isProvider}) => {
  const history = useHistory();
  const [stage, setStage] = useState(STAGE_REQUEST);
  const [phone, setPhone] = useState('');

  const recover = (email) => {
    history.push('/password/confirm', {email});
  };

  const goToReset = (username, code) => {
    const params = new URLSearchParams({username, code});
    history.push(`/providers/password/reset?${params.toString()}`);
  };

  const codeSent = (phoneNumber) => {
    setPhone(phoneNumber);
    setStage(STAGE_VERIFY);
  };

  const classes = useStyles();
  const rightPanel = !isProvider && (
    <div className={classes.circle}>
      <Typography variant="h2" color="primary">
        Are you a service provider?
      </Typography>
      <Typography variant="body1" color="primary" className={classes.text}>
        This is the password reset page for <b>participants</b>.  If you are a service provider, please follow the link below.
      </Typography>
      <Button label="Service Provider Login" className={classes.button} to="/providers/login"/>
    </div>
  );
  const title = isProvider ? 'Service Provider Password Recovery' : 'Password Recovery';
  return (
    <AuthFormPage title="Clickability Password Recovery" rightPanel={rightPanel}>
      {stage === STAGE_VERIFY ? (
        <PhoneVerifyForm
          phone={phone}
          title={title}
          onVerified={goToReset}
          onChangeNumber={() => setStage(STAGE_REQUEST)}
        />
      ) : (
        <PasswordRecoveryForm
          onComplete={recover}
          onMobileCodeSent={codeSent}
          initialMethod={phone ? METHOD_MOBILE : METHOD_EMAIL}
          onBack={() => history.push(isProvider ? '/providers/login' : '/login')}
          isProvider={isProvider}
          title={title}
        />
      )}
    </AuthFormPage>
  );
};

PasswordRecoveryPage.propTypes = {
  isProvider: PropTypes.bool,
};

export default PasswordRecoveryPage;
